export default __webpack_public_path__ + "static/media/vox-img-legacy-021.e33fafd3.jpg";